// import React from "react";
// import {
//   ArrowRightLeft,
//   Download,
//   Factory,
//   Play,
//   Users2,
//   Workflow,
// } from "lucide-react";
// import { motion } from "framer-motion";
// import PageHero from "../components/common/PageHero";
// import StatGrid from "../components/common/StatGrid";
// import DataTableCard from "../components/common/DataTableCard";
// import Accounts from "./production/Accounts";
// import CategorySubCategory from "./production/CategorySubCategory"
// import Warehouse from "./production/Warehouse";
// import ProductSections from "./production/ProductSections";
// import ProductionSteps from "./production/ProductionSteps";
// import Products from "./production/Products";
// import Incentives from "./production/Incentives";
// import PriceList from "./production/PriceList";
// import Costing from "./production/Costing";
// import { useOutletContext } from "react-router-dom";
// import WarehouseForm from "./production/WarehouseForm";
// export default function Production() {
//   const { activeSub } = useOutletContext();
//     const componentMap = {
//     accounts: <Accounts />,
//     "category-subcategory-units": <CategorySubCategory />,
//     warehouse: <Warehouse />,
//     "create-warehouse": <WarehouseForm />,
//     "product-sections": <ProductSections />,
//     "production-steps": <ProductionSteps />,
//     products: <Products />,
//     incentives: <Incentives />,
//     "price-list": <PriceList />,
//     costing: <Costing />,
//   };
//     if (componentMap[activeSub]) {
//     return componentMap[activeSub];
//   }
//   console.log("activeSub:", activeSub);
//   return (
//     <div className="erp-page-grid">
//       <PageHero
//         badge="Production floor"
//         title="A cleaner manufacturing board with stronger motion feedback."
//         subtitle="Every stage now reads like real software: focused actions, obvious queue status and easier worker visibility."
//         actions={
//           <>
//             <motion.button className="erp-btn erp-btn-ghost" whileTap={{ scale: 0.97 }}>
//               <ArrowRightLeft size={15} /> Move stage
//             </motion.button>
//             <motion.button className="erp-btn erp-btn-primary" whileTap={{ scale: 0.97 }}>
//               <Play size={15} /> Start batch
//             </motion.button>
//           </>
//         }
//       />

//       <StatGrid
//         items={[
//           {
//             title: "Active stages",
//             value: "5",
//             meta: "All core steps running",
//             trend: "Live",
//             tone: "success",
//             icon: Workflow,
//           },
//           {
//             title: "Workers engaged",
//             value: "126",
//             meta: "Across all shifts",
//             trend: "+9",
//             tone: "success",
//             icon: Users2,
//           },
//           {
//             title: "Process loss",
//             value: "1.9%",
//             meta: "Inside tolerance band",
//             trend: "Safe",
//             tone: "success",
//             icon: Factory,
//           },
//           {
//             title: "Batches due",
//             value: "14",
//             meta: "Need same-day closure",
//             trend: "Push",
//             tone: "warning",
//             icon: Download,
//           },
//         ]}
//       />

//       <div className="erp-grid erp-grid-3">
//         {[
//           ["Assorting", "Balanced", "success"],
//           ["Ghat", "Stable", "neutral"],
//           ["MM", "High queue", "warning"],
//           ["Cut & Polish", "Balanced", "success"],
//           ["Final Assorting", "Ready", "success"],
//           ["Workers", "Full coverage", "neutral"],
//         ].map(([title, label, tone]) => (
//           <motion.section
//             key={title}
//             className="erp-card"
//             whileHover={{ y: -4 }}
//             whileTap={{ scale: 0.99 }}
//             initial={{ opacity: 0, y: 16 }}
//             animate={{ opacity: 1, y: 0 }}
//           >
//             <div className="erp-card-head">
//               <div>
//                 <h3>{title}</h3>
//                 <p>Stage visibility redesigned to feel lighter, tighter and more professional.</p>
//               </div>
//               <span className={`erp-pill ${tone}`}>{label}</span>
//             </div>
//           </motion.section>
//         ))}
//       </div>

//       <div className="erp-grid erp-grid-2">
//         <section className="erp-card">
//           <div className="erp-card-head">
//             <div>
//               <h3>Worker efficiency</h3>
//               <p>Quick read on worker mix, availability and quality confidence.</p>
//             </div>
//           </div>
//           <div className="erp-list compact">
//             {[
//               ["Ramesh", "MM specialist • 94% quality score • 6 lots active"],
//               ["Pooja", "Final assorting • fastest closure time this shift"],
//               ["Mohan", "Ghat line • stable output with low rejection"],
//             ].map(([title, text]) => (
//               <div key={title} className="erp-list-row">
//                 <div className="erp-avatar-pill">{title.slice(0, 2).toUpperCase()}</div>
//                 <div>
//                   <strong>{title}</strong>
//                   <p>{text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>

//         <section className="erp-card">
//           <div className="erp-card-head">
//             <div>
//               <h3>Capacity focus</h3>
//               <p>Progress bars with lighter styling and better clarity.</p>
//             </div>
//           </div>
//           <div className="erp-progress-stack">
//             {[
//               ["MM utilization", 91, "Strong use, but queue smoothing still needed."],
//               ["Cut & polish", 73, "There is room to absorb more load."],
//               ["Final assorting", 66, "Ready to take extra lots if required."],
//             ].map(([title, value, text]) => (
//               <div key={title} className="erp-progress-card">
//                 <div className="erp-progress-top">
//                   <strong>{title}</strong>
//                   <span>{value}%</span>
//                 </div>
//                 <div className="erp-progress-line">
//                   <span style={{ width: `${value}%` }} />
//                 </div>
//                 <p>{text}</p>
//               </div>
//             ))}
//           </div>
//         </section>
//       </div>

//       <DataTableCard
//         title="Recent production entries"
//         subtitle="Latest stage transactions with worker, output and loss visibility."
//         columns={[
//           { key: "date", label: "Date" },
//           { key: "lot", label: "Lot" },
//           { key: "stage", label: "Stage" },
//           { key: "worker", label: "Worker" },
//           { key: "output", label: "Output" },
//           { key: "loss", label: "Loss" },
//         ]}
//         rows={[
//           {
//             date: "18-04-2026",
//             lot: "LOT-2401",
//             stage: "MM",
//             worker: "Ramesh",
//             output: "980 pcs",
//             loss: <span className="erp-pill success">1.8%</span>,
//           },
//           {
//             date: "18-04-2026",
//             lot: "LOT-2405",
//             stage: "Ghat",
//             worker: "Mohan",
//             output: "1.2 kg",
//             loss: <span className="erp-pill neutral">2.4%</span>,
//           },
//         ]}
//       />
//     </div>
//   );
// }

import { useSearchParams } from "react-router-dom";
import Warehouse from "./production/Warehouse.js";
import WarehouseForm from "./production/WarehouseForm.js";
import CategorySubCategory from "../pages/production/CategorySubCategory.js";
import AddCategory from "./production/AddCategory.js";
import PageHero from "../components/common/PageHero.jsx";
import StatGrid from "../components/common/StatGrid.jsx";
import { motion } from "framer-motion";
import DataTableCard from "../components/common/DataTableCard.jsx";
import {
  ArrowRightLeft,
  Download,
  Factory,
  Play,
  Users2,
  Workflow,
} from "lucide-react";
import Products from "./production/Products.js";
import AddProduct from "./production/AddProduct.js";
import PriceList from "./production/PriceList.js";
import AddSubCategory from "./production/AddSubCategory.js";
import Accounts from "./production/Accounts.js";
import Unit from "./production/Unit.js";
import ProductSections from "./production/ProductSections.js";
import ProductionSteps from "./production/ProductionSteps.js";
import Costing from "./production/Costing.js";
import EditWarehouse from "./production/EditWarehouse.js";
export default function Production() {
  const [searchParams] = useSearchParams();
  const view = searchParams.get("view");
  
  // 🔥 dynamic id extract
  const id = view?.split("-")[2];

  // 🔥 component map
  const componentMap = {
    // Warehouse
    accounts : <Accounts/>,
    units : <Unit/>,
    warehouse: <Warehouse />,
    "create-warehouse": <WarehouseForm mode="create" />,
    "edit-warehouse": <EditWarehouse mode="edit" id={id} />,
    "warehouse-view": <WarehouseForm mode="view" id={id} />,
    products: <Products />,
   
    "add-product": <AddProduct />,
    "edit-product": <AddProduct />,


    "price-list": <PriceList />,
    // Category
    category: <CategorySubCategory />,
    "add-category": <AddCategory />,
    "add-subcategory": <AddSubCategory />,
    // Future pages (just add here 👇)
    // "product": <Products />,
    "product-sections": <ProductSections />,
    "production-steps": <ProductionSteps/>,
    costing : <Costing/>
  };

  // 🔥 match logic
  const matchedKey = Object.keys(componentMap).find((key) =>
    view?.startsWith(key),
  );

  if (matchedKey) {
    return componentMap[matchedKey];
  }

  // 🔥 default dashboard
  return (
    <div className="erp-page-grid">
      <PageHero
        badge="Production floor"
        title="A cleaner manufacturing board with stronger motion feedback."
        subtitle="Every stage now reads like real software: focused actions, obvious queue status and easier worker visibility."
        actions={
          <>
            <motion.button
              className="erp-btn erp-btn-ghost"
              whileTap={{ scale: 0.97 }}
            >
              <ArrowRightLeft size={15} /> Move stage
            </motion.button>
            <motion.button
              className="erp-btn erp-btn-primary"
              whileTap={{ scale: 0.97 }}
            >
              <Play size={15} /> Start batch
            </motion.button>
          </>
        }
      />

      <StatGrid
        items={[
          {
            title: "Active stages",
            value: "5",
            meta: "All core steps running",
            trend: "Live",
            tone: "success",
            icon: Workflow,
          },
          {
            title: "Workers engaged",
            value: "126",
            meta: "Across all shifts",
            trend: "+9",
            tone: "success",
            icon: Users2,
          },
          {
            title: "Process loss",
            value: "1.9%",
            meta: "Inside tolerance band",
            trend: "Safe",
            tone: "success",
            icon: Factory,
          },
          {
            title: "Batches due",
            value: "14",
            meta: "Need same-day closure",
            trend: "Push",
            tone: "warning",
            icon: Download,
          },
        ]}
      />

      <div className="erp-grid erp-grid-3">
        {[
          ["Assorting", "Balanced", "success"],
          ["Ghat", "Stable", "neutral"],
          ["MM", "High queue", "warning"],
          ["Cut & Polish", "Balanced", "success"],
          ["Final Assorting", "Ready", "success"],
          ["Workers", "Full coverage", "neutral"],
        ].map(([title, label, tone]) => (
          <motion.section
            key={title}
            className="erp-card"
            whileHover={{ y: -4 }}
            whileTap={{ scale: 0.99 }}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <div className="erp-card-head">
              <div>
                <h3>{title}</h3>
                <p>
                  Stage visibility redesigned to feel lighter, tighter and more
                  professional.
                </p>
              </div>
              <span className={`erp-pill ${tone}`}>{label}</span>
            </div>
          </motion.section>
        ))}
      </div>

      <div className="erp-grid erp-grid-2">
        <section className="erp-card">
          <div className="erp-card-head">
            <div>
              <h3>Worker efficiency</h3>
              <p>
                Quick read on worker mix, availability and quality confidence.
              </p>
            </div>
          </div>
          <div className="erp-list compact">
            {[
              ["Ramesh", "MM specialist • 94% quality score • 6 lots active"],
              ["Pooja", "Final assorting • fastest closure time this shift"],
              ["Mohan", "Ghat line • stable output with low rejection"],
            ].map(([title, text]) => (
              <div key={title} className="erp-list-row">
                <div className="erp-avatar-pill">
                  {title.slice(0, 2).toUpperCase()}
                </div>
                <div>
                  <strong>{title}</strong>
                  <p>{text}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="erp-card">
          <div className="erp-card-head">
            <div>
              <h3>Capacity focus</h3>
              <p>Progress bars with lighter styling and better clarity.</p>
            </div>
          </div>
          <div className="erp-progress-stack">
            {[
              [
                "MM utilization",
                91,
                "Strong use, but queue smoothing still needed.",
              ],
              ["Cut & polish", 73, "There is room to absorb more load."],
              ["Final assorting", 66, "Ready to take extra lots if required."],
            ].map(([title, value, text]) => (
              <div key={title} className="erp-progress-card">
                <div className="erp-progress-top">
                  <strong>{title}</strong>
                  <span>{value}%</span>
                </div>
                <div className="erp-progress-line">
                  <span style={{ width: `${value}%` }} />
                </div>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </section>
      </div>

      <DataTableCard
        title="Recent production entries"
        subtitle="Latest stage transactions with worker, output and loss visibility."
        columns={[
          { key: "date", label: "Date" },
          { key: "lot", label: "Lot" },
          { key: "stage", label: "Stage" },
          { key: "worker", label: "Worker" },
          { key: "output", label: "Output" },
          { key: "loss", label: "Loss" },
        ]}
        rows={[
          {
            date: "18-04-2026",
            lot: "LOT-2401",
            stage: "MM",
            worker: "Ramesh",
            output: "980 pcs",
            loss: <span className="erp-pill success">1.8%</span>,
          },
          {
            date: "18-04-2026",
            lot: "LOT-2405",
            stage: "Ghat",
            worker: "Mohan",
            output: "1.2 kg",
            loss: <span className="erp-pill neutral">2.4%</span>,
          },
        ]}
      />
    </div>
  );
}
